"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsImg = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const BaseImage = styled_components_1.default.img(({ cursor, desaturated }) => (Object.assign({ cursor, width: '100%', height: '100%', alignSelf: 'center', objectFit: 'cover' }, (!desaturated && typeof desaturated === 'boolean'
    ? {
        filter: 'saturate(0.7)',
    }
    : {}))));
const BsImg = props => {
    var _a;
    const { testId, lazy = true, resized, children } = props, img = __rest(props, ["testId", "lazy", "resized", "children"]);
    const src = (_a = resized === null || resized === void 0 ? void 0 : resized[0]) === null || _a === void 0 ? void 0 : _a.url;
    const loading = lazy ? 'lazy' : undefined;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BaseImage, Object.assign({ cursor: img.onClick ? 'pointer' : 'default', src: src, loading: loading }, img, { "data-id": testId })),
        children));
};
exports.BsImg = BsImg;
//# sourceMappingURL=bs-img.js.map